import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  AUTH_FORM_USERNAME: {
    en: 'Username',
    de: 'Nutzername',
  },
  AUTH_FORM_PASSWORD: {
    en: 'Password',
    de: 'Passwort',
  },
};
